import { WeaTools } from 'ecCom'

export const getSearchCondition = () => {
    return  WeaTools.callApi('/api/hrm/online/getSearchCondition','GET');
}
export const getSearchList = (params) => {
    return WeaTools.callApi('/api/hrm/online/getSearchResult', 'POST', params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/online.js